import React, { useEffect, useState } from "react"
import { Button, Table } from "react-bootstrap"
import "../Style/Style.scss"
import { ApiClient } from "../../ApiClient"
import AddClawbackModal from "./AddClawbackModal"
import CurrentWindow from "./CurrentWindow"

export default function ClawbackSpecs(props) {

    const [selectedClawback, setSelectedClawback] = useState({})
    const [addModalShow, setAddModalShow] = useState(false)
    const [addModalEditMode, setAddModalEditMode] = useState(false)
    const [clawbackList, setClawbackList] = useState([])

    const onEditClawback = (index) => {
        setAddModalEditMode(true)
        setSelectedClawback(clawbackList[index])
        setAddModalShow(true)
    }

    const onDeleteClawback = (index) => {

        if(!window.confirm(`Are you sure you want to delete ${clawbackList[index].iso_name} ?`)) return

        const group_id = clawbackList[index].group_id == null ? null : clawbackList[index].group_id.replaceAll(' ', '').split(',').filter(gid => gid !== null || gid !== "")

        ApiClient.post({
            url: "/api/bonus/DeleteClawback",
            body: {
                group_id: group_id,
            }
        }).then(json => {
            if(!json.data.success){
                window.alert(json.data.message)
                return
            }
            getClawbackList()
    }).catch(err => {
        });
    }

    const getClawbackList = () => {
        ApiClient.get({
            url: "/api/bonus/GetClawbackList"
        }).then(json => {
            setClawbackList(json.data);
        }).catch(err => {
        });
    }

    useEffect(() => {
        getClawbackList()
    }, [])

    return (
        <>
        <div className="bonusCurrentWindow">
            <CurrentWindow windowType="C" />
        </div>
        <div className="clawbackSpecs">
            <div className="specsTitle">
                Clawback Requirements
                <Button variant="secondary" size="sm" className="float-right py-0" onClick={() => setAddModalShow(true)}>&#x002B;</Button>
            </div>
            <div className="bonusIncludeISOList">
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>ISO</th>
                            <th>Group ID</th>
                            <th>Days for Closure</th>
                            <th>Days for Volume</th>
                            <th>Volume Threshold</th>
                            <th>Non-Processing</th>
                            <th>Monthly Volume Threshold</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {clawbackList.map((clawback, i) => (
                            <tr key={i}>
                                <td>
                                    {clawback.iso_name || "Default"}
                                </td>
                                <td>
                                    {clawback.group_id}
                                </td>
                                <td>
                                    {clawback.closure_days}
                                </td>
                                <td>
                                    {clawback.volume_days}
                                </td>
                                <td>
                                    {clawback.volume_threshold}
                                </td>
                                <td>
                                    {clawback.non_processing ? <>&#x2714;</> : <></>}
                                </td>
                                <td>
                                    {clawback.monthly_volume_threshold}
                                </td>
                                <td className="text-right">
                                    <Button variant="outline-info" size="sm" className="py-0 mr-2 border-0" onClick={() => onEditClawback(i)}>&#x270E;</Button>
                                    {i != 0 && <Button variant="outline-danger" size="sm" className="py-0 border-0" onClick={() => onDeleteClawback(i)}>&#x2716;</Button>}
                                </td>
                            </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
        </div>
        <AddClawbackModal
            data={selectedClawback}
            show={addModalShow}
            onHide={() => { setAddModalShow(false); setAddModalEditMode(false); setSelectedClawback() }}
            onEdit={() => { getClawbackList(); setSelectedClawback() }}
            editMode={addModalEditMode}
        />
        </>
    )
}

